import {TourbookMutation} from "./types";
import {STATUS_ERROR, STATUS_LOADING, STATUS_SUCCESS} from "../const";

export default {
    [TourbookMutation.REQUEST](state) {
        state.status = STATUS_LOADING;
    },
    [TourbookMutation.SUCCESS](state, data) {
        state.status = STATUS_SUCCESS;
        state.items = data.items;
        state.total = data.total;
    },
    [TourbookMutation.ERROR](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
    },
    [TourbookMutation.RELEASE_SUCCESS](state, schedule) {
        state.status = STATUS_SUCCESS;

        state.items.forEach((item) => {
            if(item.id !== schedule.id) {
                return;
            }

            item.released = 1;
            item.releasedDate = (new Date()).toISOString();
        });
    },
    [TourbookMutation.UPDATE_SUCCESS](state, schedule) {
        state.status = STATUS_SUCCESS;

        state.items.forEach((item) => {
            if(item.id !== schedule.id) {
                return;
            }

            item.releaseChanges = true;
        });
    },
};
